export function previewFiles(fileTiles) {
  // Only fetch Docket-owned endpoints; legacy Drive links stay external.
  return fileTiles.filter((file) => file.fileId || file.key === 'upload');
}

export function defaultAgreementFile(fileTiles, executedFileId) {
  const files = previewFiles(fileTiles).filter((file) => file.fileKind !== 'reference');
  const pinned = files.find((file) => file.fileId === executedFileId);
  if (pinned) return pinned;
  return [...files].sort((a, b) =>
    Number(!!b.signed) - Number(!!a.signed) ||
    (b.uploadedAt || '').localeCompare(a.uploadedAt || '') ||
    (b.fileId || '').localeCompare(a.fileId || '')
  )[0] || null;
}

export function previewFilePath(contractId, file) {
  const base = `/contracts/${encodeURIComponent(contractId)}`;
  return file.fileId
    ? `${base}/files/${encodeURIComponent(file.fileId)}/download`
    : `${base}/file`;
}

export function previewFileStatus(file) {
  return file.fileKind === 'reference' ? 'Reference' : file.signed ? 'Executed' : file.version || 'Draft';
}
